import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const radioButtonWrapper = css`
  display: flex;
  margin: 0 0 ${spacing.lg}px 0;
  cursor: pointer;
  color: var(--neutral-black-base);

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: 0 0 ${spacing.sm}px 0;
    `,
  )}
`;

export const radioButtonWrapperDisabled = css`
  cursor: default;
  color: var(--neutral-black-40);
`;

export const radioButtonLabelText = css`
  flex-grow: 1;
  margin: ${spacing.base}px 0 0 ${spacing.xs}px;
  ${theme.responsiveText.BODY.MD};
`;
